import { Box, Paper, Typography, useTheme } from "@mui/material";
import React, { useEffect, useRef } from "react";

import ChatSuggestions from "./Suggestions";
import MessageContent from "./Message";
import DotsLoadingAnimation from "./DotsLoadingAnimation";

function MessageList({ messages, suggestions, onSuggestionSelected }) {
    const containerRef = useRef(null);
    const theme = useTheme();

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    }, [messages]);

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.scrollTo({
                top: containerRef.current.scrollHeight,
                behavior: 'smooth'
            });
        }
    }, [suggestions]);

    return (
        <Box
            ref={containerRef}
            sx={{
                flex: 1,
                overflowY: 'auto',
                overflowX: 'hidden',
                mb: theme.spacing(2),
            }}
        >
            <Box
                sx={{
                    p: 1
                }}
            >
                {messages.map((msg) => {
                    const isUser = msg.role === 'user';
                    return (
                        <Box
                            padding={theme.spacing(0)}
                            key={msg.id}
                            display="flex"
                            justifyContent={isUser ? 'flex-end' : 'flex-start'}
                            my={theme.spacing(1)}
                        >
                            <Paper
                                elevation={0}
                                sx={{
                                    overflow: 'hidden',
                                    p: 0,
                                    px: {
                                        xs: 1,
                                        sm: 1,
                                        md: 1.5,
                                        lg: 1.5,
                                    },
                                    backgroundColor: isUser
                                        ? theme.palette.primary.dark
                                        : theme.palette.mode === 'dark'
                                            ? theme.palette.grey[900]
                                            : theme.palette.grey[100],
                                    color: isUser
                                        ? theme.palette.primary.contrastText
                                        : theme.palette.text.primary,
                                    maxWidth: {
                                        xs: '100%',
                                        sm: '100%',
                                        md: '70%',
                                        lg: '70%',
                                    },
                                    borderRadius: isUser
                                        ? '10px 0 10px 10px'
                                        : '0 10px 10px 10px',
                                }}
                            >
                                {msg.content
                                    ? <MessageContent content={msg.content} type="text" />
                                    : <Box
                                        sx={{
                                            p: 1,
                                            width: '75px',

                                        }}>
                                        <DotsLoadingAnimation />
                                    </Box>}
                            </Paper>
                        </Box>

                    );
                })}
            </Box>
            <ChatSuggestions
                onSuggestionSelected={onSuggestionSelected}
                suggestions={suggestions || []}
            />
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
            >
                <Typography
                    variant="caption"
                    color="text.secondary"
                    align="center"
                >AI: Almost intelligent. Double check important information.</Typography>
            </Box>
        </Box >
    );
}

export default MessageList;
